export const COUNTERTOP_DEFAULT_OVERHANG = 2;
export const COUNTERTOP_DEFAULT_OVERHANG_BAR_ISLAND = 10;
